import { sanitizeDateTime } from "../../timeFunctions/timeFns"
import Cookies from "js-cookie";

const TimeCookie = 'dtp3'

export function setNewRange(start, end) {
  const newValues = {startTime: start, endTime: end}
  Cookies.set(TimeCookie, JSON.stringify(newValues))
  return [start, end]
}
export function setRange (obj) {
  if (obj?.startTime && obj?.endTime) {
    Cookies.set(TimeCookie, JSON.stringify(obj))
    return true
  }
  return false
}
export function setDefaultRange(){
  const end = new Date()
  const start = new Date(Date.now() - 24 * 3600000)
  return setNewRange([start, end])
}
export function getRangeObj() {
  const strCookie = Cookies.get(TimeCookie)
  return strCookie ? JSON.parse(strCookie) : undefined
}
export function getRangeFrom(obj) {
  if (obj?.startTime || obj?.endTime) {
    const start = sanitizeDateTime(obj?.startTime)
    const end = sanitizeDateTime(obj?.endTime)
    return [start, end]  
  }
  return [undefined, undefined]
}
export function getTimeRange() {
  const saved = getRangeObj()
  return saved ? getRangeFrom(saved) : [undefined, undefined]
}
export function namedRange([start, end]) {
  if (!Array.isArray(arguments[0]))
    return undefined
  return start || end ? {startTime: start, endTime: end} : undefined
}
export function getSavedRange() {
  return namedRange(getRangeFrom(getRangeObj()))
}
export function eraseTimeRange() {
  Cookies.remove(TimeCookie)
}